/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import Imgix from 'js/components/Imgix';

import { logo } from 'bundles/coursera-plus/utils/courseraPlusUtils';
import ChipButton from 'bundles/search-common/components/experiments/filters2024/ChipButton';
import { useChooseCourseraLite } from 'bundles/search-common/providers/LearnerProvider';

import _t from 'i18n!nls/search-common';

type Props = { isActive: boolean; onClick: () => void };
const styles = {
  courseraPlusFilter: css`
    display: flex;
    align-items: center;
  `,
  tierLogo: css`
    vertical-align: top;
    position: relative;
  `,
  logoWrapper: css`
    border-radius: 4px;
    max-height: 16px;
    overflow: hidden;
    position: relative;

    &::before {
      content: '';
      width: 90%;
      height: 90%;
      display: block;
      position: absolute;
      z-index: 0;
      top: 5%;
      left: 5%;
      background-color: var(--cds-color-neutral-background-primary);
    }
  `,
};
export const CourseraPlusFilterChipButton = (props: Props): React.ReactElement => {
  const { isActive, onClick } = props;
  const isCLite = useChooseCourseraLite();
  const buttonText = isCLite ? _t('Coursera Lite') : _t('Coursera Plus');
  return (
    <ChipButton
      onClick={onClick}
      prefix={
        <div css={styles.logoWrapper}>
          <Imgix
            src={isCLite ? logo.LITE_PILL_BLUE : logo.PLUS_PILL_BLUE}
            maxHeight={16}
            css={styles.tierLogo}
            aria-hidden={true}
            alt=""
          />
        </div>
      }
      isActive={isActive}
    >
      {buttonText}
    </ChipButton>
  );
};

export default CourseraPlusFilterChipButton;
